import React, { useState, useRef } from 'react';

import Page from '../common/Page';
import { CTAButton } from '../common/Button'
import { VerseText, VerseName } from '../common/Text'

import verseMap from '../../assets/verse.json'
import resultDeco from '../../assets/result_decoration.png'
import backgroundImg from '../../assets/bg_result.png'

const ctaStyle = {        
    width: '100%',
    height: '3.5rem',            
    marginTop: '3.5em'   
}

const decoImageStyle = {
    display: 'block',
    margin: 'auto',
    width: '3.5rem',
    height: '3.5rem',
    paddingTop: '4.75rem'
}

export default function Verse(props) {
    const selected = useRef(false)    
    const [verse, setVerse] = useState('')
    const [verseText, setVerseText] = useState('')
    
    if (!selected.current && props.visible && props.result !== '') {
        selected.current = true
        const resultVerse = mapResultToVerse(props.result)
        setVerse(resultVerse.verse)
        setVerseText(resultVerse.verseText)
    }
    
    return (
        <Page backgroundImg={backgroundImg}>            
            <img src={resultDeco} alt={'deco result'} style={decoImageStyle}/>            
            <VerseText style={{paddingTop: '0.75rem', marginRight: '1rem', marginLeft: '1rem'}}>{verseText}</VerseText>
            <VerseName style={{paddingTop: '1rem'}}>{verse}</VerseName>                                      
            <CTAButton style={ctaStyle} onClick={props.nextStep}>
                AMEN
            </CTAButton>                                                     
        </Page>
    )    
}

function mapResultToVerse(index) {    
    return verseMap[index]
}